var exports = {
  "p": "SidebarResizeHandle.module__handle___eVRET0",
  "q": "SidebarResizeHandle.module__indicator___eVRET0",
};

module.exports = exports;
